import { render, staticRenderFns } from "./Metadatos.vue?vue&type=template&id=e3c417f2&"
import script from "./Metadatos.vue?vue&type=script&lang=js&"
export * from "./Metadatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports